export default "__VITE_ASSET__DSoyyEiv__"